module.exports = __webpack_public_path__ + "static/media/Dublin-City-University.76d34672.png";